/**
 * Infraestructura del Clan — Servicios (Mocks)
 * Mocks para activar UI de edificios/mejoras sin backend real.
 * Slugs: dojo, archive, forge, war_hall, sanctuary
 * Rarezas de materiales: common, rare, epic, legendary
 */

/**
 * @typedef {'idle'|'upgrading'|'cooldown'} InfraStatus
 * @typedef {{ slug:string, name:string, icon:string, level:number, status:InfraStatus, eta?:string|null }} InfraBuilding
 * @typedef {{ active:null|{ slug:string, endsAt:string }, canAccelerate:boolean }} InfraQueue
 */

/** Catálogo base estático (labels e iconos) */
const BUILDING_CATALOG = [
  { slug: 'dojo', name: 'Dojo', icon: '🥋' },
  { slug: 'archive', name: 'Archivo', icon: '📚' },
  { slug: 'forge', name: 'Forja', icon: '⚒️' },
  { slug: 'war_hall', name: 'Salón de Guerra', icon: '⚔️' },
  { slug: 'sanctuary', name: 'Santuario', icon: '⛩️' },
];

/**
 * Mock: Overview de infraestructura por clan
 * @param {string|number} clanIdOrSlug
 * @returns {Promise<{ clanIdOrSlug:string|number, buildings:InfraBuilding[], queue:InfraQueue, updatedAt:string }>}
 */
export async function fetchClanInfraOverview(clanIdOrSlug) {
  const now = new Date().toISOString();
  const buildings = BUILDING_CATALOG.map((b) => ({
    ...b,
    level: 0,          // Placeholder: todos en nivel 0
    status: 'idle',    // Sin mejora activa
    eta: null,
  }));
  const queue = { active: null, canAccelerate: false };
  return { clanIdOrSlug, buildings, queue, updatedAt: now };
}